import { setUsersList, setConsentsList } from './actions/layout'

export const setRoute = ({store}) => {
  const path = window.location.hash.split('/')
  const rxuuid = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

  // set property detail if url matches
  if (path[1] === 'users') {
    store.dispatch(setUsersList())
  } else if (path[1] === 'consents') {
    store.dispatch(setConsentsList())
  } else {
    store.dispatch(setConsentsList())
  }
//  store.dispatch(setSalesList())
}



// WEBPACK FOOTER //
// ./src/router.js